import { datastageApi } from 'datastage/api';

/**
 * Hook for stale titles operations
 */
export const useStaleTitlesData = () => {
    const fetchStaleTitlesStats = async () => {
        try {
            const response = await datastageApi.staleTitlesStats();

            if (response?.error) {
                throw new Error(response.error);
            }

            return response;
        } catch (error) {
            console.error('Error fetching stale titles stats:', error);
            throw new Error(
                error.message || 'Failed to fetch stale titles statistics'
            );
        }
    };

    const downloadStaleTitlesCsv = async (failureReason = null) => {
        try {
            const response = await datastageApi.staleTitlesCsvExport(failureReason);

            if (!response || !response.data) {
                throw new Error('No data received from server');
            }

            const blob = response.data;
            const contentDisposition = response.headers['content-disposition'];
            let filename = 'stale-titles.csv';

            if (contentDisposition) {
                const filenameMatch = contentDisposition.match(/filename[^;=\n]*=\s*["']?([^"';\n]+)["']?/i);
                if (filenameMatch && filenameMatch[1]) {
                    filename = filenameMatch[1].trim();
                }
            }

            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.download = filename;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);

        } catch (error) {
            console.error('Error downloading stale titles CSV:', error);
            throw new Error(
                error.message || 'Failed to download CSV file'
            );
        }
    };

    const downloadStaleTitlesInRlCsv = async (failureReason = null) => {
        try {
            const response = await datastageApi.staleTitlesInRlCsvExport(failureReason);

            if (!response || !response.data) {
                throw new Error('No data received from server');
            }

            const blob = response.data;
            const contentDisposition = response.headers['content-disposition'];
            let filename = 'stale-titles-rl.csv';

            if (contentDisposition) {
                const filenameMatch = contentDisposition.match(/filename[^;=\n]*=\s*["']?([^"';\n]+)["']?/i);
                if (filenameMatch && filenameMatch[1]) {
                    filename = filenameMatch[1].trim();
                }
            }

            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.download = filename;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);

        } catch (error) {
            console.error('Error downloading stale titles in RL CSV:', error);
            throw new Error(
                error.message || 'Failed to download CSV file'
            );
        }
    };

    const downloadStaleTitlesByReasonInRlCsv = async (failureReason) => {
        try {
            const response = await datastageApi.staleTitlesInRlCsvExport(failureReason);

            if (!response || !response.data) {
                throw new Error('No data received from server');
            }

            const blob = response.data;
            const contentDisposition = response.headers['content-disposition'];
            let filename = 'stale-titles-rl.csv';

            if (contentDisposition) {
                const filenameMatch = contentDisposition.match(/filename[^;=\n]*=\s*["']?([^"';\n]+)["']?/i);
                if (filenameMatch && filenameMatch[1]) {
                    filename = filenameMatch[1].trim();
                }
            }

            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.download = filename;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);

        } catch (error) {
            console.error('Error downloading stale titles by reason in RL CSV:', error);
            throw new Error(
                error.message || 'Failed to download CSV file'
            );
        }
    };

    return {
        fetchStaleTitlesStats,
        downloadStaleTitlesCsv,
        downloadStaleTitlesInRlCsv,
        downloadStaleTitlesByReasonInRlCsv,
    };
};
